// src/components/demo/DemoApprovals.js
//
// Approvals sheet (SPEC §3.1 / §8.3 screen 1b) — WAKA-role staff + admins
// review pending partner-staff requests. Partner staff never see this
// (Firestore rules also enforce it server-side).

import React, { useState } from 'react';
import { FScreen, FHeader, FHeadline, FBtn, FLabel } from '../foam/FoamPrimitives';
import { decideStaffRequest } from '../../services/demoService';

export default function DemoApprovals({ user, requests, onBack }) {
  const [busyId, setBusyId] = useState(null);

  const decide = async (request, approve) => {
    setBusyId(request.id);
    try { await decideStaffRequest(request, approve, user); } finally { setBusyId(null); }
  };

  return (
    <FScreen
      header={<FHeader right={<FLabel>Approvals</FLabel>} />}
      footer={<FBtn ghost onClick={onBack}>Back</FBtn>}
    >
      <FHeadline size={42}>Staff<br /><FHeadline.Accent>requests.</FHeadline.Accent></FHeadline>

      {requests.length === 0 && (
        <p className="font-sans text-[15px]" style={{ color: 'var(--foam-ink-2)' }}>
          No pending requests. When partner staff ask for access, they land here.
        </p>
      )}

      {requests.map((r) => (
        <div key={r.id} style={{ background: 'var(--foam-paper-2)', padding: 16 }} className="flex flex-col gap-[10px]">
          <div className="font-sans font-bold text-[16px]">{r.name || '(no name)'}</div>
          <FLabel>{r.affiliation || '—'} · {r.email || r.id}</FLabel>
          <div className="flex gap-[10px]">
            <FBtn primary height={52} disabled={busyId === r.id} onClick={() => decide(r, true)}>
              Approve
            </FBtn>
            <FBtn ghost height={52} disabled={busyId === r.id} onClick={() => decide(r, false)}>
              Decline
            </FBtn>
          </div>
        </div>
      ))}
    </FScreen>
  );
}
